module.exports = __webpack_public_path__ + "img/75689.96c9f749.svg";